import React, { useState } from 'react';
import { Card, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import SubscriptionModal from './SubscriptionModal';

type SubscriptionWallProps = {
    role: string;
    canSubscribe: boolean;
};

const SubscriptionWall: React.FC<SubscriptionWallProps> = ({ role, canSubscribe }) => {
    const [showModal, setShowModal] = useState(false);
    const navigate = useNavigate();

    const isStaff = role === 'staff';

    const title = isStaff ? 'Franchise Not Subscribed' : 'Subscription Required';
    const message = isStaff
        ? 'Your franchise is not subscribed yet, so you cannot view any features. Please contact your franchise admin.'
        : 'Subscribe to view features. Your franchise must have an active subscription before you can use this portal.';

    const handleLogout = () => {
        navigate('/auth/logout');
    };

    return (
        <>
            <div className="d-flex justify-content-center align-items-center py-5">
                <Card style={{ maxWidth: 600 }} className="w-100">
                    <Card.Body className="text-center">
                        <Card.Title className="mb-3">{title}</Card.Title>
                        <Card.Text className="mb-4">{message}</Card.Text>
                        <div className="d-flex justify-content-center gap-2">
                            {canSubscribe && (
                                <Button className="ha-btn ha-btn-primary" onClick={() => setShowModal(true)}>
                                    Subscribe
                                </Button>
                            )}
                            <Button className="ha-btn ha-btn-primary" onClick={handleLogout}>
                                Logout
                            </Button>
                        </div>
                    </Card.Body>
                </Card>
            </div>
            {canSubscribe && (
                <SubscriptionModal show={showModal} onHide={() => setShowModal(false)} />
            )}
        </>
    );
};

export default SubscriptionWall;

